export default __webpack_public_path__ + "static/media/Insight.89ce25da.svg";